export { default as ProfileScene } from './Scene';



// WEBPACK FOOTER //
// ./src/modules/profile/index.js